import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/PageBody.scss';
import Notifications from "./Notifications";

export default function PageBody({
    children,
    className,
    sidebar,
    ...props
}) {
    const classes = classNames(styles.pageBody, className, {
        [styles.hasSidebar]: !!sidebar,
    });

    return (
        <div {...props} className={classes}>
            <Notifications/>

            {sidebar && (
                <div className={styles.pageBodySidebar}>
                    {sidebar}
                </div>
            )}
            <div className={styles.pageBodyInner}>
                {children}
            </div>
        </div>
    );
}

PageBody.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    sidebar: PropTypes.node,
};
